export const routesPaths = {
  HOMEPAGE: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  SET_PASSWORD: '/forgot-password/:token',
  GET_STARTED: '/get-started/:desiredPackageId',
  GET_STARTED_2: '/get-started-2/:desiredPackageId',
  CREATE_ACCOUNT_EXTENDED: '/create-account/:token',
  CREATE_ACCOUNT_BASE: '/create-account-base/:token',
  BUILD_PLAN: '/purchase/plan/:hash',
  ABANDONED_CHECKOUT: '/purchase/checkout/:hash/:subscriptionId',
  CHECKOUT: '/purchase/checkout/:hash',
  MARKETING_INFO: '/marketing-info/:subscriptionId/:questionName',
  WEBINAR_WIZARD: '/webinar-creator-wizard/:stepName/:subscriptionId',
  MANAGEMENT_OVERVIEW: '/management/overview',
  MANAGEMENT_BILLING: '/management/billing',
  MANAGEMENT_INVOICE: '/management/history',
  MANAGEMENT_USAGE: '/management/usage',
  VERIFY: '/verify',
  LINK_USED: '/link-used',
  CONFIRMED: '/confirmed/:subscriptionId',
  PLEASE_WAIT: '/please-wait/purchase-manager/email-validation/:id',
  ONE_LAST_STEP: '/one-last-step',
  ONE_LAST_STEP_2: '/one-last-step-2',
  CHECK_YOUR_INBOX: '/check-your-inbox',
  ADMIN: '/admin',
  ADMIN_OVERVIEW: '/admin/overview',
  ADMIN_PRODUCTS: '/admin/products/:productFamily',
  ADMIN_SUBSCRIPTIONS: '/admin/subscriptions',
  ADMIN_PARTNERS: '/admin/partners',
  ADMIN_EMAIL_VALIDATIONS: '/admin/email-validations',
  ADMIN_ENTERPRISE: '/admin/enterprise',
  ADMIN_PRODUCT_UPDATE: '/admin/update/:productFamily/:type/:name',
  ADMIN_CHECKLISTS: 'admin/checklists',
  ADMIN_ANNOUNCEMENTS: 'admin/announcements',
  PLG: '/avatar-studio/:desiredPackageId',
  PLG_HELPER: '/plg-helper',
  GET_STARTED_V2: '/get-started-v2/:desiredPackageId',
  CHECK_YOUR_INBOX_V2: '/check-your-inbox-v2',
  ONE_LAST_STEP_V2: '/one-last-step-v2',
  VERIFY_V2: '/verify-v2',
  CREATE_ACCOUNT_V2: '/create-account-v2/:token',
  LOGIN_V2: '/login-v2',
  CHECK_YOUR_INBOX_LOGIN_V2: '/check-your-inbox-login-v2',
  FORGOT_PASSWORD_V2: '/forgot-password-v2',
  SET_PASSWORD_V2: '/forgot-password-v2/:token',
  PRICING: '/pricing/:productFamily'
};

export const routesPathsList = Object.entries(routesPaths).map(
  ([name, path]) => ({ name, path })
);
